import axios from "axios";
import config from "@/router/globalConfig";

export default {
  getTitle(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GetTitle', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  getGender(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GetGender', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  getIDType(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GetIDType', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  getBookingStages(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GetBookingStages', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  getBookingType(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GetBookingType', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  getPersonAgeGroup(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GetPersonAgeGroups', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  getTax(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GetTaxRates', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  getAvailableSlots(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GetAvailableSlots', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  getSeatLeft(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GelSeatsLeftForSlot', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  showMyBooking(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/ShowMyBooking', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  getBookingData(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GetBookingData', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  saveBooking(_data_) {
    return axios.post(config.WEB_API_PATH + 'TicketBooking/SaveBooking', _data_, {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
    });
  },
  getVisitorDataMain(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GetVisitorData', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  saveVisitorData(_data_) {
    return axios.post(config.WEB_API_PATH + 'TicketBooking/SaveVisitorData', _data_, {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
    });
  },
  saveSingleVisitorData(_data_) {
    return axios.post(config.WEB_API_PATH + 'TicketBooking/SaveSingleVisitorData', _data_, {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
    });
  },
  generateTicketData(_data_) {
    return axios.get(config.WEB_API_PATH + 'TicketBooking/GenrateTicket', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  checkTransRequestCaptcha(_data_) {
    return axios.get(config.WEB_API_PATH + 'PaymentGatway/checkTransRequestCaptcha', {
      headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/servicesJS/Booking.js